export function hideGlobalLoader(): void {
  const globalLoader = document.getElementById('global-loader');
  globalLoader?.classList.add('fadeout');
  setTimeout(() => {
    globalLoader?.parentElement?.removeChild(globalLoader);
  }, 300);
}
